import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Apps, CommonAccessTokenService, FooterComponent, HeaderComponent, MainLayoutComponent } from '@wm-libs/core';
import { AccountsService } from './core/services/accounts.service';
import { Subscription } from 'rxjs';
import { Account } from './core/interfaces/accounts.interface';
import { NgIf } from '@angular/common';
import { environment } from '../environments/environment';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  standalone: true,
  imports: [MainLayoutComponent, RouterOutlet, HeaderComponent, MatSidenavModule, FooterComponent, NgIf],
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnDestroy {
  title = 'Wemine Tech';

  private accountsSubscription!: Subscription;
  selectedFarm!: Account | null;
  hideBalance = true;
  accounts!: Account[] | null;
  isAccessTokenPage = false;

  app!: Apps;
  env = environment;

  balance = 0;

  constructor(private accountsService: AccountsService, private commonAccessTokenService: CommonAccessTokenService) {
    this.isAccessTokenPage = this.commonAccessTokenService.isAccessTokenPage();

    if (this.isAccessTokenPage) {
      return;
    }

    this.accountsSubscription = this.accountsService.accounts$.subscribe((accounts) => {
      if (!accounts?.length) {
        return;
      }

      for (const account of accounts) {
        if (account.current) {
          this.selectedFarm = account;
          this.balance = this.selectedFarm.balance;
        }
      }
    });

    this.accountsService.getAccounts().subscribe();
  }

  ngOnDestroy(): void {
    if (this.accountsSubscription) this.accountsSubscription.unsubscribe();
  }
}
